import { Navigate } from "react-router-dom";
import { useQueryURLSearchParams } from "~/util/hooks";
import paths from "~/paths";
import { useState } from "react";
import SearchQuery from "~/searchQuery";

const SearchRedirect = () => {
  const searchParams = useQueryURLSearchParams();
  const [searchQuery] = useState<SearchQuery>(SearchQuery.fromQueryString(searchParams));

  return searchQuery ? <Navigate to={paths.construct.browse(searchQuery)} /> : null;
};

export default SearchRedirect;
